import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiClock, FiMapPin, FiMessageSquare } = FiIcons;

export default function KidCard({ kid }) {
  return (
    <div className="bg-white rounded-2xl p-4 shadow-sm border border-slate-200 hover:shadow-md transition-shadow flex items-start gap-4">
      <div className="relative">
        <img 
          src={kid.avatar} 
          alt={kid.name} 
          className="w-16 h-16 rounded-2xl object-cover border-2 border-slate-100 shadow-sm"
        />
        <div className="absolute -bottom-2 -right-2 w-6 h-6 bg-green-400 rounded-full border-2 border-white flex items-center justify-center">
          <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
        </div>
      </div>
      
      <div className="flex-1">
        <div className="flex justify-between items-start">
          <h4 className="font-bold text-lg text-[#1a365d]">{kid.name}</h4>
          <button className="text-slate-400 hover:text-[#1a365d]">
            <SafeIcon icon={FiMessageSquare} />
          </button>
        </div>
        
        <div className="mt-2 space-y-1">
          <div className="flex items-center gap-2 text-sm text-slate-600">
            <SafeIcon icon={FiMapPin} className="text-slate-400 text-xs" />
            <span className="truncate">{kid.location}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-slate-600 bg-yellow-50 rounded-md px-2 py-1 border border-yellow-100 mt-1 inline-flex">
            <SafeIcon icon={FiClock} className="text-yellow-600 text-xs" />
            <span className="text-yellow-800 text-xs font-semibold">Pickup: {kid.pickup}</span>
          </div>
        </div>
      </div>
    </div>
  );
}